module.exports = __webpack_public_path__ + "static/media/basiskaart-squared.99e4a171.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/01/04/assets/basiskaart-squared.jpg
// module id = 429
// module chunks = 0